module.exports = __webpack_public_path__ + "static/media/hraswo_hee.b5392995.ogg";